import React, {Component} from 'react';
import ReactModal from "react-modal";
import { Card, Button,Col,Row } from 'reactstrap'
import Modal from "react-modal";
import ReactPlayer from "react-player";
import startingTest  from './../img/helpDesk/videos/startingTest.jpg'
import reviewTest  from './../img/helpDesk/videos/reviewTest.jpg'
import teacherWalkthrough  from './../img/helpDesk/videos/teacherWalkthrough.jpg'
import {connect} from 'react-redux'



ReactModal.setAppElement('#root');
class Helpdesk extends Component {
    
state = {
        showModal: false,
        tutorialUrl : null,
        student : false,
        studentT : false,
        teacher : false,
        isStudent : false
      }

      componentDidMount(){
        if(this.props.userObj && this.props.userObj.role === "Student"){
            this.setState({isStudent:true})
        }
        else{
            this.setState({isStudent:false})
        }
    }

closeModal = () =>{
  this.setState({showModal:false})
}

student = () => {
  this.setState({student:true,studentT:false,teacher:false,showModal:true})

}
studentT = () => {
  this.setState({student:false,studentT:true,teacher:false,showModal:true})

}
Teacher = () => {
  this.setState({student:false,studentT:false,teacher:true,showModal:true})
  
}


formCall = () => {
  var script = document.createElement('script');
 script.src = "https://paperform.co/__embed"; document.body.appendChild(script); 
}

  render() {

    let {student,studentT,teacher,isStudent} = this.state

    let tutorialUrl = null
    if(student){
      tutorialUrl = "https://masteryprep.wistia.com/medias/iv8usbsdpw"
    }
    else if(studentT){
      tutorialUrl = "https://masteryprep.wistia.com/medias/2m6gjy4hqd"
    }
    else if(teacher){
      tutorialUrl = "https://masteryprep.wistia.com/medias/9j417ce1u6"
    }
   
     
    const divPaddingStyle = {
        paddingTop: "14px"
      };
      const customStyles = {
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          color: "#62b6e8",
          backgroundColor: "rgb(216, 216, 216)"
        }
      };
      const spanStyle = {
        color: "#6e6e6e",
        float: "right",
        cursor: "pointer"
      };
      let {showModal} = this.state
      return (
        <Card className="top-card" >
    
       {showModal && 
        <Row>
          <Col md="12" sm="12" xs="12">
            <Modal
              isOpen={this.state.showModal}
              style={customStyles}
              shouldCloseOnEsc={true}
              contentLabel="Tutorial"
              onRequestClose={this.closeModal}
            >
              <ReactPlayer url={tutorialUrl} controls={true} />
              <div style={divPaddingStyle}>
                <span onClick={this.closeModal} style={spanStyle}>
                  Close
                </span>
              </div>
            </Modal>
          </Col>
        </Row>}
        <Row style={{"padding":"0 70px"}}>
        {
          <div>
              <Row className="mt-5">
                <Col md="12" sm="12" xs="12" style={{"color":"#00C1AB"}}><h5>MasteryPrep Online Help</h5>
                </Col><br />
              </Row>
              <Row>
                <Col md="12" sm="12" xs="12">
                  <p>
                    {
                      `Welcome to the help page for MasteryPrep Online. Check out the videos below for a 
                      better understanding of how to use this platform.`
                    }
                  </p>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <strong>{"Student Tutorials:"}</strong>
                </Col>
              </Row>
              <Row className="mt-3 ">
                <Col onClick={this.student} md= "5" className="custom_help">
                 <img  style={{"width":"60%" , "cursor":"pointer"}} src={startingTest}/> <br />
                  <div className="mt-1 div_class">{"Starting a Test"}</div>
                </Col>

                <Col onClick={this.studentT} md= "5" className="custom_help">
                <img  style={{"width":"60%" , "cursor":"pointer"}} src={reviewTest}/><br />
                <div className="mt-1 div_class">{"Reviewing a Finished Test"}</div>
                </Col>
              </Row>

              {!isStudent && <React.Fragment>
              <Row className="mt-5">
                <Col>
                  <strong>{"Teacher Tutorials:"}</strong>
                </Col>
              </Row>
              <Row className="mt-3 mb-5">
                <Col onClick={this.Teacher} md= "5" className="custom_help" >
                  <img  style={{"width":"60%" , "cursor":"pointer"}} src={teacherWalkthrough}/><br />
                <div className="mt-1 div_class">{"Teacher Walkthrough"}</div>
                </Col>
              </Row>
              </React.Fragment>}
              <hr />
              <div className="mt-3">
                <p>
                  {
                    `If you have any additional question or would like to 
                    submit feedback, please fill out the form below.`
                  }
                </p>
              </div>
              <div className="mt-3 mb-5" data-paperform-id="c2jy6gae">
                <p>
                  {this.formCall()}
                </p>
              </div>
             
          </div>
        }
        </Row>
      </Card>
   )
  }
}
const mapStatetoProps = state =>{
    return {
        stateon : state
    }
}


export default connect(mapStatetoProps)(Helpdesk);



// WEBPACK FOOTER //
// ./src/containers/Helpdesk.js